(function() {
  'use strict';

  // The app block and the app embed both pull in this file, so a merchant
  // with both enabled would otherwise bind every handler twice.
  if (window.__gemfindWishlistProductInit) return;
  window.__gemfindWishlistProductInit = true;

  // Wait for common.js to load
  function waitForCommon(callback) {
    if (window.GemfindWishlistCommon) {
      callback();
    } else {
      setTimeout(() => waitForCommon(callback), 50);
    }
  }

  waitForCommon(() => {
    const productBlock = document.querySelector('.gemfind-wishlist-product');
    if (!productBlock) return;

    const button = productBlock.querySelector('.gemfind-wishlist-product__button');
    const productId = productBlock.getAttribute('data-wishlist-product-id');
    const productHandle = productBlock.getAttribute('data-wishlist-product-handle');
    const shopDomain = typeof Shopify !== 'undefined' ? Shopify.shop : '';
    const common = window.GemfindWishlistCommon;
    
    let sessionId = common.getSessionId();
  let appSettings = null;
  let defaultWishlistId = '--';
  let iconColor = '#000';
  let textColor = '#000';
  let fontSize = '16';
  let textLabel = 'Add to Wishlist';
  let planUpgradable = false;
  let cachedWishlists = null; // Cache wishlists to avoid repeated API calls
  let isInWishlist = false;

  let blockConfig = {};
  try {
    const configAttr = productBlock.getAttribute('data-wishlist-config');
    if (configAttr) {
      blockConfig = JSON.parse(configAttr);
      if (blockConfig.iconColor) iconColor = blockConfig.iconColor;
      if (blockConfig.textColor) textColor = blockConfig.textColor;
      if (blockConfig.fontSize) fontSize = blockConfig.fontSize;
      if (blockConfig.labelText) textLabel = blockConfig.labelText;
    }
  } catch (e) {
    console.error('Failed to parse wishlist config:', e);
  }
  
  // Fallback: read label from DOM if not in config
  if (!blockConfig.labelText && button) {
    const labelEl = button.querySelector('.gemfind-wishlist-product__label');
    if (labelEl) {
      textLabel = labelEl.textContent.trim();
    }
  }

  async function apiCall(endpoint, data) {
    return common.apiCall(endpoint, data, shopDomain, common.ensureSessionId(), common.getCustomerId());
  }

  async function checkProductInWishlist() {
    try {
      const result = await apiCall('productInWishlist', {
        handle: productHandle,
        saveforlater: 'false',
        product_id: productId || '',
      });
      return result.status === 'success' && result.data && result.data.wishlist_status === true;
    } catch (error) {
      return false;
    }
  }

  async function getDefaultWishlistId() {
    try {
      if (appSettings && appSettings.multiple_wishlist_option === "false") {
        return "My Wishlist";
      }
      const result = await apiCall('myWishlist', {
        saveforlater: 'false',
        product_id: '',
        handle: ''
      });
      if (result.status === 'success' && result.data && result.data.wishlists) {
        const wishlists = result.data.wishlists;
        const wishlistKeys = Object.keys(wishlists).filter(key => key !== 'U0ZM');
        if (wishlistKeys.length > 0) {
          return wishlists[wishlistKeys[0]];
        }
      }
      return '--';
    } catch (error) {
      if (appSettings && appSettings.multiple_wishlist_option === "false") {
        return "My Wishlist";
      }
      return '--';
    }
  }

  async function addToWishlist(wishlistId, quantity = 1, comments = '') {
    try {
      const result = await apiCall('addToWishlist', {
        handle: productHandle,
        saveforlater: 'false',
        product_id: productId || '',
        quantity: quantity,
        comments: comments,
        wishlist_id: wishlistId,
      });
      if (result.status === 'success') {
        isInWishlist = true;
        updateButtonState(true);
      }
      return result.status === 'success';
    } catch (error) {
      console.error('Failed to add to wishlist:', error);
      return false;
    }
  }

  async function removeFromWishlist() {
    try {
      const result = await apiCall('removeWishlist', {
        handle: productHandle,
        saveforlater: 'false',
        product_id: productId || '',
      });
      if (result.status === 'success') {
        isInWishlist = false;
        updateButtonState(false);
      }
      return result.status === 'success';
    } catch (error) {
      console.error('Failed to remove from wishlist:', error);
      return false;
    }
  }

  let loadingAppSettings = false;
  let appSettingsPromise = null;

  async function loadAppSettings() {
    // If already loading, return the existing promise to prevent concurrent calls
    if (loadingAppSettings && appSettingsPromise) {
      return appSettingsPromise;
    }

    loadingAppSettings = true;
    appSettingsPromise = (async () => {
      try {
        const result = await apiCall('appSetting', { shop_domain: shopDomain });
        if (result.status === 'success' && result.data) {
          appSettings = result.data;
          // Apply merchant custom CSS (saved from admin)
          if (common && typeof common.injectCustomCss === 'function') {
            common.injectCustomCss(appSettings.custom_css);
          }
          // Design settings (colors, font size, label) are now only from block settings
          // Only load non-design settings from API
          if (result.data.multiple_wishlist_option === "false") {
            defaultWishlistId = "My Wishlist";
          } else {
            defaultWishlistId = await getDefaultWishlistId();
          }
          updateButtonColors();
          updateButtonLabel();
          return appSettings;
        } else {
          // API call succeeded but no data returned
          console.warn('appSetting API returned no data');
          return appSettings || null;
        }
      } catch (error) {
        console.error('Failed to load app settings:', error);
        updateButtonColors();
        updateButtonLabel();
        // Return existing appSettings if available, otherwise null
        return appSettings || null;
      } finally {
        loadingAppSettings = false;
        appSettingsPromise = null;
      }
    })();

    return appSettingsPromise;
  }

  async function checkPlanUpgradable() {
    try {
      const result = await apiCall('wishlistCount', {});
      if (result.status === 'success' && result.data && result.data.wishlist_plan_upgradable) {
        planUpgradable = result.data.wishlist_plan_upgradable;
      }
    } catch (error) {
      console.error('Failed to check plan upgradable:', error);
    }
  }

  function updateButtonColors() {
    if (button) {
      const icons = button.querySelectorAll('.heart');
      icons.forEach(icon => icon.style.color = iconColor);
      const label = button.querySelector('.gemfind-wishlist-product__label');
      if (label) {
        label.style.color = textColor;
        label.style.fontSize = fontSize + 'px';
      }
    }
  }

  function updateButtonLabel() {
    if (button) {
      const label = button.querySelector('.gemfind-wishlist-product__label');
      if (label && (!button.getAttribute('aria-pressed') || button.getAttribute('aria-pressed') === 'false')) {
        label.textContent = textLabel;
      }
    }
  }

  function updateButtonState(inWishlist) {
    if (button) {
      button.setAttribute('aria-pressed', inWishlist ? 'true' : 'false');
      const outlineIcon = button.querySelector('.heart-icon-outline');
      const filledIcon = button.querySelector('.heart-icon-filled');
      const label = button.querySelector('.gemfind-wishlist-product__label');
      
      if (inWishlist) {
        if (outlineIcon) outlineIcon.style.display = 'none';
        if (filledIcon) filledIcon.style.display = 'block';
        if (label) label.textContent = 'Remove from Wishlist';
      } else {
        if (outlineIcon) outlineIcon.style.display = 'block';
        if (filledIcon) filledIcon.style.display = 'none';
        if (label) label.textContent = textLabel || 'Add to Wishlist';
      }
    }
  }

  async function showWishlistSelectionModal() {
    // Open modal immediately with product details only (matching old version behavior)
    const productDetail = await common.getProductDetails(productHandle, shopDomain);
    const currency = window.ShopifyAnalytics?.meta?.currency || 'USD';
    const price = productDetail ? common.formatPrice(productDetail.price, currency) : '';
    
    const { dialog, closeBtn } = common.createDialog();
    const quantityField = appSettings && appSettings.plan > 1 ? `
      <div class="gf-w-quantity">
        <label style="margin-right: 10px;"><b>Quantity</b></label>
        <input type="number" id="wishlist-quantity" value="1" min="1" />
      </div>
    ` : '';

    // Match exact structure from old version (no inline styles, use CSS classes)
    dialog.innerHTML = `
      <div class="gf-wishlist-create-select-form">
        <h2 class="gf-wishlist-head">Add Product To Your Wishlist</h2>
        <div class="gf-wishlist-main-container">
          <div class="gf-wishlist-product-details">
            <h4>Product Details : </h4>
            <div>
              <p><b>Name - </b>${common.escapeHtml(productDetail?.title || '')}</p>
              <p><b>Price - </b>${price}</p>
            </div>
            ${quantityField}
          </div>
          <div class="gf-wishlists-data">
            ${cachedWishlists ? renderWishlistOptions(cachedWishlists) : '<div id="wishlist-loading" style="text-align: center; padding: 20px;">Loading wishlists...</div>'}
          </div>
        </div>
        <div class="add_to_list_btns">
          <button id="wishlist-add-btn" ${cachedWishlists ? '' : 'disabled'} style="background-color: #000; color: #fff; border: 0; padding: 9px 30px; border-radius: 24px; cursor: pointer; ${cachedWishlists ? '' : 'opacity: 0.6;'}">Add to Wishlist</button>
        </div>
      </div>
    `;
    dialog.appendChild(closeBtn);
    document.body.appendChild(dialog);
    requestAnimationFrame(() => {
      dialog.showModal();
    });

    const modal = dialog;
    
    // Only fetch wishlists if not cached (matching old version - only fetch when needed)
    if (!cachedWishlists) {
      loadWishlistsIntoModal(modal, productDetail);
    } else {
      setupWishlistModalHandlers(modal);
    }
  }

  function renderWishlistOptions(wishlists) {
    const wishlistKeys = Object.keys(wishlists);
    let html = `<h5 style="margin: 0;">${wishlistKeys.length > 0 ? 'Select Your Existing Wishlist' : ''}</h5>`;
    
    wishlistKeys.forEach((key, index) => {
      const inputId = `wishlist-option-${index}`;
      html += `
        <div class="gf-wishlists-input">
          <input value="${common.escapeHtml(wishlists[key])}" type="radio" name="wishlist-select" id="${inputId}" />
          <label for="${inputId}">${common.escapeHtml(key)}</label>
        </div>
      `;
    });
    
    html += `<hr class="gf-seperator" />`;
    html += `
      <div class="gf-for-new-add">
        <input type="radio" name="wishlist-select" id="wishlist-new-toggle" />
        <label for="wishlist-new-toggle"><h5>Do you want create a Wishlist?</h5></label>
      </div>
      <div id="wishlist-new-field" style="display: none;">
        <input type="text" id="wishlist-new-name" placeholder="Add new Wishlist name" />
      </div>
    `;
    
    if (appSettings && appSettings.wishlist_comments_option !== "false") {
      html += `
        <div class="gf-for-new-add">
          <input type="checkbox" id="wishlist-comments-toggle" />
          <label for="wishlist-comments-toggle"><h5>Do you want drop comments?</h5></label>
        </div>
        <div id="wishlist-comments-field" style="display: none;">
          <textarea id="wishlist-comments" placeholder="Add Comments"></textarea>
        </div>
      `;
    }
    
    return html;
  }

  async function loadWishlistsIntoModal(modal, productDetail) {
    try {
      const result = await apiCall('myWishlist', {
        saveforlater: 'false',
        product_id: '',
        handle: ''
      });

      const wishlists = {};
      if (result.status === 'success' && result.data && result.data.wishlists) {
        Object.keys(result.data.wishlists).forEach(key => {
          if (key !== 'U0ZM') {
            wishlists[key] = result.data.wishlists[key];
          }
        });
      }

      // Cache wishlists for future use (matching old version state preservation)
      cachedWishlists = wishlists;

      const loadingEl = modal.querySelector('#wishlist-loading');
      const listEl = modal.querySelector('.gf-wishlists-data');

      // Replace loading with actual content
      listEl.innerHTML = renderWishlistOptions(wishlists);

      // Enable add button
      const addBtn = modal.querySelector('#wishlist-add-btn');
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.style.opacity = '1';
      }

      // Setup handlers
      setupWishlistModalHandlers(modal);
    } catch (error) {
      console.error('Failed to load wishlists:', error);
      const loadingEl = modal.querySelector('#wishlist-loading');
      if (loadingEl) {
        loadingEl.textContent = 'Failed to load wishlists. Please try again.';
      }
    }
  }

  function setupWishlistModalHandlers(modal) {
    const newToggle = modal.querySelector('#wishlist-new-toggle');
    const newField = modal.querySelector('#wishlist-new-field');
    const commentsToggle = modal.querySelector('#wishlist-comments-toggle');
    const commentsFieldEl = modal.querySelector('#wishlist-comments-field');
    const addBtn = modal.querySelector('#wishlist-add-btn');

    // Handle new wishlist toggle
    if (newToggle && newField) {
      const handleNewToggle = () => {
        newField.style.display = newToggle.checked ? 'block' : 'none';
        if (newToggle.checked) {
          // Uncheck other wishlist options
          modal.querySelectorAll('input[name="wishlist-select"]:not(#wishlist-new-toggle)').forEach(radio => {
            radio.checked = false;
          });
        }
      };
      newToggle.addEventListener('change', handleNewToggle);
      // Also handle click on the label
      const newLabel = modal.querySelector('label[for="wishlist-new-toggle"]');
      if (newLabel) {
        newLabel.addEventListener('click', (e) => {
          // Let the default label behavior handle the toggle, then update display
          setTimeout(handleNewToggle, 0);
        });
      }
    }

    // Handle comments toggle
    if (commentsToggle && commentsFieldEl) {
      const handleCommentsToggle = () => {
        commentsFieldEl.style.display = commentsToggle.checked ? 'block' : 'none';
      };
      commentsToggle.addEventListener('change', handleCommentsToggle);
      // Also handle click on the label
      const commentsLabel = modal.querySelector('label[for="wishlist-comments-toggle"]');
      if (commentsLabel) {
        commentsLabel.addEventListener('click', (e) => {
          // Let the default label behavior handle the toggle, then update display
          setTimeout(handleCommentsToggle, 0);
        });
      }
    }

    // Handle existing wishlist selection - uncheck new wishlist toggle when selecting existing
    modal.querySelectorAll('input[name="wishlist-select"]:not(#wishlist-new-toggle)').forEach(radio => {
      radio.addEventListener('change', () => {
        if (radio.checked && newToggle) {
          newToggle.checked = false;
          if (newField) {
            newField.style.display = 'none';
          }
        }
      });
    });

    addBtn.addEventListener('click', async () => {
      const selectedWishlist = modal.querySelector('input[name="wishlist-select"]:checked');
      const isNewWishlist = newToggle && newToggle.checked;
      const newWishlistName = isNewWishlist ? modal.querySelector('#wishlist-new-name')?.value.trim() : '';
      const quantity = modal.querySelector('#wishlist-quantity') ? parseInt(modal.querySelector('#wishlist-quantity').value) || 1 : 1;
      const comments = commentsToggle && commentsToggle.checked ? modal.querySelector('#wishlist-comments')?.value : '';

      if (!selectedWishlist && !isNewWishlist) {
        alert('Please select or create a wishlist');
        return;
      }

      if (isNewWishlist && !newWishlistName) {
        alert('Please enter a wishlist name');
        return;
      }

      if (quantity <= 0) {
        alert('Please enter a valid quantity');
        return;
      }

      const wishlistId = isNewWishlist ? newWishlistName : selectedWishlist.value;
      
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
      
      const success = await addToWishlist(wishlistId, quantity, comments);
      
      if (success) {
        common.closeAndRemoveDialog(modal);
        cachedWishlists = null; // Clear cache to refetch on next open
        // Small delay to ensure modal is fully closed before opening next one
        setTimeout(async () => {
          // Ensure appSettings is fully loaded with all properties before checking request_info
          if (!appSettings || !appSettings.hasOwnProperty('request_info') || !appSettings.hasOwnProperty('captcha_select')) {
            await loadAppSettings();
            // Double-check after load
            if (!appSettings || !appSettings.hasOwnProperty('request_info')) {
              console.warn('appSettings still incomplete after load');
            }
          }
          if (appSettings && appSettings.request_info === "true") {
            await showRequestInfoModal();
          } else {
            if (window.GemfindWishlist && window.GemfindWishlist.refresh) {
              window.GemfindWishlist.refresh();
            }
          }
        }, 100);
      } else {
        alert('Failed to add to wishlist');
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Wishlist';
      }
    });
  }

  async function showRequestInfoModal() {
    // Always ensure appSettings is fully loaded before showing the modal
    // Force reload if missing or incomplete
    if (!appSettings || !appSettings.hasOwnProperty('captcha_select') || !appSettings.site_key) {
      const loadedSettings = await loadAppSettings();
      // If still not loaded, try one more time
      if (!loadedSettings || !loadedSettings.hasOwnProperty('captcha_select')) {
        console.warn('appSettings incomplete, retrying load...');
        await loadAppSettings();
      }
    }
    
    // Final validation - ensure appSettings exists and has required properties
    if (!appSettings) {
      console.error('appSettings is still null after load attempts');
      // Continue anyway - reCAPTCHA just won't show
    }
    
    const { dialog, closeBtn } = common.createDialog();
    // Use loose equality to handle both string "1" and number 1
    // Also check for truthy values (1, "1", true)
    const captchaEnabled = appSettings && (
      appSettings.captcha_select == 1 || 
      appSettings.captcha_select === "1" || 
      appSettings.captcha_select === 1 ||
      appSettings.captcha_select === true
    );
    const needsRecaptcha = captchaEnabled && appSettings.site_key;
    
    // Debug logging
    console.log('reCAPTCHA check:', {
      appSettings: appSettings ? 'loaded' : 'null',
      captcha_select: appSettings?.captcha_select,
      site_key: appSettings?.site_key ? 'present' : 'missing',
      needsRecaptcha: needsRecaptcha
    });
    const recaptchaHtml = needsRecaptcha ? `
      <div id="recaptcha-container" style="margin-bottom: 15px;"></div>
    ` : '';

    dialog.innerHTML = `
      <div class="Diamond-form--xx-small request--more-info-popup" style="padding: 30px; position: relative;">
        <div class="requested-form">
          <h2 style="margin-top: 0;">Request More Information</h2>
        </div>
        <form class="email-form">
          <div class="form-field">
            <div style="display: flex; gap: 10px; margin-bottom: 15px;">
              <div style="width: 100%;">
                <label style="display: block; margin-bottom: 5px;">* First name:</label>
                <input type="text" id="fname" required style="width: 100%; padding: 10px; border: 1px solid #CBCBCB; border-radius: 7px;" />
                <p id="error-first" style="color: red; font-size: 12px; margin: 5px 0 0 0;"></p>
              </div>
              <div style="width: 100%;">
                <label style="display: block; margin-bottom: 5px;">* Last name:</label>
                <input type="text" id="lname" required style="width: 100%; padding: 10px; border: 1px solid #CBCBCB; border-radius: 7px;" />
                <p id="error-last" style="color: red; font-size: 12px; margin: 5px 0 0 0;"></p>
              </div>
            </div>
            <div style="margin-bottom: 15px;">
              <label style="display: block; margin-bottom: 5px;">* Phone Number:</label>
              <input type="tel" id="phone" required style="width: 100%; padding: 10px; border: 1px solid #CBCBCB; border-radius: 7px;" />
              <p id="error-phone" style="color: red; font-size: 12px; margin: 5px 0 0 0;"></p>
            </div>
            <div style="margin-bottom: 15px;">
              <label style="display: block; margin-bottom: 5px;">* Email:</label>
              <input type="email" id="email" required style="width: 100%; padding: 10px; border: 1px solid #CBCBCB; border-radius: 7px;" />
              <p id="error-email" style="color: red; font-size: 12px; margin: 5px 0 0 0;"></p>
            </div>
            ${recaptchaHtml}
            <div style="margin-top: 20px;">
              <div class="gf-form-buttons" style="display: flex; gap: 10px;">
                <button type="button" id="submit-inquiry-btn" ${needsRecaptcha ? 'disabled' : ''} style="background-color: #000; color: #fff; border: 0; padding: 9px 30px; border-radius: 24px; cursor: pointer; ${needsRecaptcha ? 'opacity: 0.6; cursor: not-allowed;' : ''}">Submit Inquiry</button>
                <button type="button" class="skip-btn" style="background-color: #ccc; color: #000; border: 0; padding: 9px 30px; border-radius: 24px; cursor: pointer;">Skip</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    `;
    dialog.appendChild(closeBtn);
    document.body.appendChild(dialog);
    
    // Show modal and wait for it to be visible before rendering reCAPTCHA
    requestAnimationFrame(() => {
      dialog.showModal();
    });

    let recaptchaWidgetId = null;

    // Load and render reCAPTCHA if enabled
    if (needsRecaptcha) {
      // Wait for modal to be fully rendered and visible
      await new Promise(resolve => setTimeout(resolve, 100));
      
      const recaptchaContainer = dialog.querySelector('#recaptcha-container');
      if (recaptchaContainer) {
        console.log('Found reCAPTCHA container, rendering...');
        try {
          recaptchaWidgetId = await common.renderRecaptcha(recaptchaContainer, appSettings.site_key, (token) => {
            console.log('reCAPTCHA token received');
            dialog.setAttribute('data-recaptcha-token', token);
            const submitBtn = dialog.querySelector('#submit-inquiry-btn');
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.style.opacity = '1';
              submitBtn.style.cursor = 'pointer';
            }
          });
          console.log('reCAPTCHA rendered successfully, widget ID:', recaptchaWidgetId);
        } catch (error) {
          console.error('Failed to load reCAPTCHA:', error);
          // If reCAPTCHA fails to load, enable submit button anyway
          const submitBtn = dialog.querySelector('#submit-inquiry-btn');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.style.opacity = '1';
            submitBtn.style.cursor = 'pointer';
          }
        }
      } else {
        console.error('reCAPTCHA container not found in dialog!');
      }
    } else {
      console.log('reCAPTCHA not needed:', { needsRecaptcha, appSettings });
    }

    // Handle skip button
    dialog.querySelector('.skip-btn').addEventListener('click', () => {
      common.closeAndRemoveDialog(dialog);
      if (window.GemfindWishlist && window.GemfindWishlist.refresh) {
        window.GemfindWishlist.refresh();
      }
    });

    // Handle submit button
    dialog.querySelector('#submit-inquiry-btn').addEventListener('click', async () => {
      const fname = dialog.querySelector('#fname').value.trim();
      const lname = dialog.querySelector('#lname').value.trim();
      const phone = dialog.querySelector('#phone').value.trim();
      const email = dialog.querySelector('#email').value.trim();
      const recaptchaToken = dialog.getAttribute('data-recaptcha-token');

      // Validation
      let hasError = false;
      ['first', 'last', 'phone', 'email'].forEach(field => {
        const errorEl = dialog.querySelector(`#error-${field}`);
        if (field === 'email') {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!email || !emailRegex.test(email)) {
            errorEl.textContent = 'Please enter valid email';
            hasError = true;
          } else {
            errorEl.textContent = '';
          }
        } else {
          const value = field === 'first' ? fname : field === 'last' ? lname : phone;
          const msg = field === 'first' ? 'Please enter your First name' : field === 'last' ? 'Please enter your Last name' : 'Please enter your Phone number';
          if (!value) {
            errorEl.textContent = msg;
            hasError = true;
          } else {
            errorEl.textContent = '';
          }
        }
      });

      if (hasError) return;

      // Use loose equality to handle both string "1" and number 1
      if (appSettings && (appSettings.captcha_select == 1 || appSettings.captcha_select === "1") && appSettings.site_key && !recaptchaToken) {
        alert('Please complete the reCAPTCHA');
        return;
      }

      const submitBtn = dialog.querySelector('#submit-inquiry-btn');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';

      try {
        let variantId = '', variantName = '', variantSku = '';
        if (window.meta && window.meta.product && window.meta.product.variants) {
          const variantSelect = document.querySelector('select[name="id"], input[name="id"]');
          if (variantSelect) {
            const selectedVariantId = variantSelect.value;
            const variant = window.meta.product.variants.find(v => v.id === parseInt(selectedVariantId));
            if (variant) {
              variantId = variant.id;
              variantName = variant.name;
              variantSku = variant.sku || '';
            }
          }
        }

        const result = await apiCall('sendMailData', {
          handle: productHandle,
          fname: fname,
          lname: lname,
          phone: phone,
          email: email,
          variantId: variantId,
          productName: variantName,
          productSku: variantSku,
          productUrl: window.location.href,
          productId: productId || ''
        });

        if (result.status === 'success') {
          alert('Email Sent Successfully!');
          // Reset reCAPTCHA if it was used
          if (recaptchaWidgetId !== null) {
            common.resetRecaptcha(recaptchaWidgetId);
          }
          dialog.removeAttribute('data-recaptcha-token');
          common.closeAndRemoveDialog(dialog);
        } else {
          alert('Email Could not be sent');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit Inquiry';
        }
      } catch (error) {
        console.error('Error sending email:', error);
        alert('Email Could not be sent');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit Inquiry';
      }
    });
  }

  // Initialize - apply block settings immediately
  updateButtonColors();
  updateButtonLabel();

  const initCheck = async () => {
    // Ensure appSettings is loaded BEFORE checking productInWishlist
    await loadAppSettings();
    const inWishlist = await checkProductInWishlist();
    isInWishlist = inWishlist;
    updateButtonState(inWishlist);
    updateButtonColors();
    await checkPlanUpgradable();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCheck);
  } else {
    initCheck();
  }

  if (button) {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isPressed = button.getAttribute('aria-pressed') === 'true';
      
      if (isPressed) {
        // Remove from wishlist - OPTIMISTIC UPDATE FIRST
        if (!planUpgradable) {
          // Update UI immediately before API call
          isInWishlist = false;
          updateButtonState(false);
          
          button.disabled = true;
          const success = await removeFromWishlist();
          if (!success) {
            // Revert optimistic update on failure
            isInWishlist = true;
            updateButtonState(true);
          } else {
            // Success - refresh wishlist count
            if (window.GemfindWishlist && window.GemfindWishlist.refresh) {
              window.GemfindWishlist.refresh();
            }
          }
          button.disabled = false;
        } else {
          common.showPlanUpgradeModal();
        }
      } else {
        // Always ensure appSettings is fully loaded before proceeding
        if (!appSettings || !appSettings.hasOwnProperty('multiple_wishlist_option')) {
          await loadAppSettings();
        }
        
        if (planUpgradable) {
          common.showPlanUpgradeModal();
        } else {
          if (appSettings && appSettings.multiple_wishlist_option === "true") {
            await showWishlistSelectionModal();
          } else {
            button.disabled = true;
            const success = await addToWishlist(defaultWishlistId || "My Wishlist");
            if (!success) {
              updateButtonState(false);
            } else {
              // Ensure appSettings is fully loaded with all properties before checking request_info
              if (!appSettings || !appSettings.hasOwnProperty('request_info') || !appSettings.hasOwnProperty('captcha_select')) {
                await loadAppSettings();
                // Double-check after load
                if (!appSettings || !appSettings.hasOwnProperty('request_info')) {
                  console.warn('appSettings still incomplete after load');
                }
              }
              if (appSettings && appSettings.request_info === "true") {
                await showRequestInfoModal();
              } else {
                if (window.GemfindWishlist && window.GemfindWishlist.refresh) {
                  window.GemfindWishlist.refresh();
                }
              }
            }
            button.disabled = false;
          }
        }
      }
    });
  }
  });
})();
